// extracted by mini-css-extract-plugin
export default {"titleContainer":"style_titleContainer__dRTFG","title":"style_title__vmEeh","subTitle":"style_subTitle__r8l57","addClassButton":"style_addClassButton__Pb1Yt"};